import {useState} from 'react';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useAppDispatch} from '../../../../../helpers/reduxHelpers';
import {CrmSyncModel} from '../../../../../models/api/crmSyncModel';
import {updateCrmSyncAsyncAction} from '../../../../../store/data/crmSync/crmSyncActions';
import {
  computeCrmSyncMappingFromCustomFieldMapping,
  computeRequiredFields,
  CrmToFrontCustomFieldMapping,
} from '../crmSyncHelpers';

export function useUpdateCrmSync(
  crmSync: CrmSyncModel | undefined,
  mappedFields: ReadonlyArray<CrmToFrontCustomFieldMapping>,
  onRequestClose: Handler,
  listId?: string,
) {
  const [isUpdatingCrmSync, setIsUpdatingCrmSync] = useState(false);
  const dispatch = useAppDispatch();

  const onUpdateCrmSyncAsync = async () => {
    if (!crmSync) {
      return;
    }
    const customFieldMapping = [...computeRequiredFields(crmSync.source), ...mappedFields];

    setIsUpdatingCrmSync(true);
    await dispatch(
      updateCrmSyncAsyncAction(
        crmSync.id,
        computeCrmSyncMappingFromCustomFieldMapping(customFieldMapping),
        listId,
      ),
    );
    setIsUpdatingCrmSync(false);
    onRequestClose();
  };
  return {isUpdatingCrmSync, onUpdateCrmSyncAsync};
}
